import clsx from 'clsx';
interface IProps {
  className?: string;
}

export const NoResultsFound = ({ className }: IProps) => {
  return (
    <div
      data-testid="no-results"
      className={clsx(
        'h-[150px] w-full flex text-purple-8/50 text-center justify-center items-center text-4xl font-bold',
        {
          [`${className}`]: className,
        },
      )}
    >
      No results found
    </div>
  );
};
